import { APIProvider } from '@vis.gl/react-google-maps';
import { API_KEY } from '@contexts/map/constants';
import { appRoutes } from '@utils/consts';

export const builderPortalRoutes = [
  {
    path: appRoutes.builderPortal(':token'),
    lazy: async () => {
      const { BuilderPortal } = await import('@pages/builderPortal');
      return {
        Component: () => (
          <APIProvider apiKey={API_KEY}>
            <BuilderPortal />
          </APIProvider>
        ),
      };
    },
  },
  {
    path: appRoutes.builderPortalJob(':token', ':jobId'),
    lazy: async () => {
      const { BuilderPortalJob } = await import('@pages/builderPortal/job');
      return { Component: BuilderPortalJob };
    },
  },
];
